// extracted by mini-css-extract-plugin
module.exports = {"streamSection":"SearchProducts_streamSection__AJPwz","autoComplete":"SearchProducts_autoComplete__sgSDc","text":"SearchProducts_text__2OUJP"};